import React from 'react'



export const StarsBackGround = () => {
    return(
        <div>
       <div className="stars"></div>
<div className="twinkling"></div>
<div className="clouds"></div>
</div>
    )
}